// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';  // ✅ Already contains Tailwind directives
import App from './App';

// Global fetch interceptor — Phase 1 auth rewrite (2026-04-23).
// Adds `credentials: 'include'` so cookies flow on every call to our API,
// and mirrors the `csrf_token` cookie into `X-CSRF-Token` on state-changing
// requests (double-submit cookie pattern). The prior X-User header injection
// has been removed — the backend now reads the user identity from the
// signed JWT in the `access_token` cookie.
(() => {
  const API_BASE = process.env.REACT_APP_API_URL || '';
  if (typeof window === 'undefined' || !window.fetch) return;
  const origFetch = window.fetch.bind(window);

  const readCsrf = () => {
    const m = document.cookie.match(/(?:^|;\s*)csrf_token=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  };

  window.fetch = (input, init = {}) => {
    try {
      const url = typeof input === 'string' ? input : input?.url || '';
      const matchesApi = API_BASE
        ? url.startsWith(API_BASE)
        : url.startsWith('/') || url.startsWith(window.location.origin);
      if (matchesApi) {
        // Always send cookies to our API
        init = { ...init, credentials: init.credentials || 'include' };

        // CSRF header on state-changing methods
        const method = (init.method || 'GET').toUpperCase();
        const unsafe = method !== 'GET' && method !== 'HEAD' && method !== 'OPTIONS' && method !== 'TRACE';
        if (unsafe) {
          const csrf = readCsrf();
          if (csrf) {
            const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined));
            if (!headers.has('X-CSRF-Token')) headers.set('X-CSRF-Token', csrf);
            init = { ...init, headers };
          }
        }
      }
    } catch { /* ignore */ }
    return origFetch(input, init);
  };
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
